module.exports = __webpack_public_path__ + "img/doorLogo24.eefa0cf0.png";